class NodeEvent {
  constructor (graph) {
    this.isNodeDown = false
    this.graph = graph
  }

  // 查找节点的子节点列表
  findChildNodes (node, nodeList) {
    return nodeList.filter((item) => {
      const itemId = item?.data?.id || item?.id
      const nodeId = node.id
      return itemId?.includes(nodeId) && itemId !== nodeId
    })
  }

  init () {
    this.graph.on('node:click', ({ node }) => {
      const nodeList = this.graph.getNodes()
      let targetNode = node
      let childList = []
      
      // 如果点击的是组合节点，找到其中的父节点
      if (node.getData()?.isGroup && node.getData()?.groupedNodes) {
        const groupedNodeIds = node.getData().groupedNodes || []
        for (const nodeId of groupedNodeIds) {
          const candidateNode = this.graph.getCellById(nodeId)
          if (candidateNode) {
            const candidateChildList = this.findChildNodes(candidateNode, nodeList)
            if (candidateChildList.length > 0) {
              targetNode = candidateNode
              childList = candidateChildList
              break
            }
          }
        }
      } else {
        childList = this.findChildNodes(node, nodeList)
      }
      
      if (childList.length) {
        const visible = !childList[0].visible
        const draftComponent = window.draftComponent
        
        // 如果父节点在组合中，先取消组合
        if (draftComponent) {
          const existingGroup = nodeList.find(n => 
            n.getData()?.isGroup && 
            n.getData()?.groupedNodes?.includes(targetNode.id)
          )
          
          if (existingGroup) {
            draftComponent.selection.reset()
            draftComponent.selection.select(existingGroup)
            draftComponent.ungroupSelectedNodes()
          }
        }
        
        // 显示或隐藏子节点
        childList.forEach(item => item.setVisible(visible))
      }
    })

    this.graph.on('node:mousedown', ({ node }) => {
      if (!node.getData()?.isGroup) {
        this.isNodeDown = true
      }
    })

    this.graph.on('node:mousemove', ({ node }) => {
      if (this.isNodeDown && node.zIndex === 1) {
        node.setZIndex(10)
      }
    })

    this.graph.on('node:mouseup', ({ node }) => {
      if (this.isNodeDown) {
        node.setZIndex(1)
      }
      this.isNodeDown = false
    })
  }
}

export default NodeEvent
